import { SvgIcon } from "@mui/material";
import React from "react";

export const SvgElectro = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M270 217.38C255.073 245.093 230.419 266.303 200.788 276.924C171.157 287.546 138.644 286.828 109.51 274.91C110.28 274.96 153.11 277.84 167.29 267.04C167.29 267.04 97.79 258.86 98.82 183.58C98.82 183.58 107.33 198.22 122.66 198.22C137.99 198.22 148.55 179.83 148.55 161.77C148.55 143.71 127.09 120.55 102.9 120.55C78.71 120.55 38.61 141.08 47.78 221.07C32.2372 194.325 26.9568 162.839 32.9242 132.486C38.8916 102.134 55.6991 74.9901 80.21 56.12C79.26 57.54 55.83 92.51 58 110C58 110 100 54 164.57 92.72C164.57 92.72 147.57 92.72 139.92 105.98C132.27 119.24 142.82 137.6 158.43 146.67C174.04 155.74 204.86 148.82 217.01 127.91C229.16 107 231.57 62 157.81 29.71H157.86C188.084 29.7126 217.323 40.4639 240.349 60.0422C263.375 79.6204 278.687 106.749 283.55 136.58C282.93 135.41 263.16 97.87 246.65 91.48C247.07 92.41 275.53 155.27 211.31 193.48C211.31 193.48 219.31 178.56 211.31 165.48C203.31 152.4 182.09 153.03 166.7 162.48C151.31 171.93 142.8 202.33 155.44 222.95C168.08 243.57 206.61 267 270 217.38Z"
      fill="#AF8EC1"
    />
  </SvgIcon>
);

export const SvgHydro = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_200)">
      <path
        d="M156.62 280C141.09 280.38 128.48 277.78 118.42 273.95C130.753 277.973 143.647 280.015 156.62 280Z"
        fill="#4CC2F1"
      />
      <path
        d="M127.39 225C127.421 227.543 128.019 230.047 129.14 232.33C133.026 240.363 139.624 246.767 147.77 250.41C152.594 252.561 157.818 253.668 163.1 253.66C182.63 253.66 191.41 241.22 192.53 236.17C191.14 243.7 179.87 260.17 156.61 260.17C148.388 260.17 140.33 257.877 133.341 253.547C126.351 249.217 120.709 243.022 117.049 235.661C113.388 228.299 111.854 220.062 112.62 211.876C113.386 203.69 116.42 195.88 121.383 189.325C126.345 182.769 133.038 177.729 140.709 174.77C148.379 171.811 156.724 171.052 164.803 172.577C172.882 174.102 180.375 177.851 186.439 183.402C192.504 188.953 196.899 196.087 199.13 204C199.22 204.26 199.29 204.53 199.36 204.81C199.43 205.09 199.47 205.24 199.52 205.46C199.66 206.12 199.76 206.788 199.82 207.46V207.57C200.165 211.475 199.149 215.378 196.946 218.62C194.743 221.862 191.487 224.243 187.73 225.36C185.068 226.147 182.255 226.281 179.53 225.75C176.248 225.102 173.228 223.504 170.847 221.153C168.467 218.802 166.83 215.804 166.14 212.53C166.031 212.028 165.947 211.521 165.89 211.01C165.176 207.641 163.324 204.619 160.645 202.454C157.966 200.289 154.624 199.112 151.18 199.12C150.413 199.12 149.648 199.177 148.89 199.29C148.39 199.37 147.9 199.47 147.42 199.59C141.708 200.952 136.623 204.202 132.988 208.813C129.353 213.425 127.381 219.128 127.39 225Z"
        fill="#4CC2F1"
      />
      <path
        d="M49.1401 97.24C48.7001 98.02 48.2701 98.81 47.8601 99.61C48.219 98.7852 48.6472 97.9924 49.1401 97.24Z"
        fill="#4CC2F1"
      />
      <path
        d="M67.13 159C67.1319 161.987 66.3119 164.917 64.7597 167.469C63.2076 170.022 60.9832 172.098 58.33 173.47C55.1705 175.109 51.5616 175.669 48.0539 175.066C44.5462 174.462 41.3323 172.728 38.9024 170.127C36.4724 167.526 34.96 164.202 34.5957 160.661C34.2314 157.121 35.0353 153.558 36.8847 150.517C38.7341 147.476 41.5276 145.123 44.8389 143.818C48.1502 142.513 51.7975 142.327 55.2246 143.288C58.6516 144.249 61.6701 146.305 63.8197 149.142C65.9692 151.979 67.1318 155.441 67.13 159Z"
        fill="#4CC2F1"
      />
      <path
        d="M85.11 212.7C85.114 215.017 84.4439 217.285 83.1815 219.227C81.919 221.17 80.1187 222.703 78 223.64C76.5869 224.264 75.0645 224.604 73.52 224.64H73.22C70.2205 224.653 67.3259 223.536 65.113 221.511C62.9 219.487 61.5311 216.702 61.2788 213.713C61.0266 210.724 61.9096 207.75 63.7519 205.383C65.5942 203.016 68.2606 201.429 71.22 200.94C71.8807 200.828 72.5499 200.774 73.22 200.78C76.3754 200.791 79.398 202.051 81.6264 204.285C83.8548 206.519 85.1074 209.545 85.11 212.7Z"
        fill="#4CC2F1"
      />
      <path
        d="M279.58 155.7C280.29 223.7 224.58 279.99 156.58 279.99C143.607 280.005 130.713 277.963 118.38 273.94C94.9099 264.99 85.38 249.27 85.08 248.78C94.8312 255.86 105.693 261.267 117.22 264.78C118.38 265.14 119.53 265.48 120.66 265.78C132.324 269.098 144.414 270.679 156.54 270.47C157.88 270.47 159.2 270.47 160.54 270.39C184.22 269.45 205.79 255.69 215.64 234.14C220.256 224.081 222.356 213.051 221.76 202C219.85 165.77 189.38 137.15 153.1 137.35C147.144 137.374 141.216 138.181 135.47 139.75L135.19 139.83C133.836 140.169 132.446 140.34 131.05 140.34C127.203 140.353 123.468 139.047 120.469 136.64C117.469 134.232 115.385 130.868 114.566 127.11C113.747 123.351 114.242 119.425 115.968 115.988C117.694 112.55 120.547 109.808 124.05 108.22H124.18L124.36 108.14H124.43L124.76 108.01L125.58 107.7C144.378 100.535 165.092 100.181 184.124 106.699C203.156 113.218 219.303 126.197 229.761 143.383C240.219 160.568 244.327 180.874 241.371 200.773C238.415 220.672 228.582 238.907 213.58 252.31C226.453 243.151 236.925 231.02 244.106 216.948C251.288 202.876 254.967 187.278 254.83 171.48C254.42 118.1 210.76 74.4 157.38 73.94C141.634 73.7964 126.085 77.4429 112.045 84.5718C98.0043 91.7008 85.8851 102.103 76.7099 114.9C76.3699 115.36 76.0499 115.82 75.7099 116.28C73.2422 119.39 69.7284 121.497 65.8226 122.209C61.9169 122.922 57.8854 122.19 54.4789 120.151C51.0724 118.112 48.523 114.904 47.3053 111.126C46.0877 107.347 46.2848 103.254 47.86 99.61C48.27 98.81 48.6999 98.02 49.1399 97.24C62.3382 73.5516 82.9945 54.8887 107.896 44.154C132.798 33.4193 160.549 31.2145 186.834 37.8825C213.118 44.5505 236.462 59.7177 253.235 81.0248C270.008 102.332 279.27 128.585 279.58 155.7Z"
        fill="#4CC2F1"
      />
      <path
        d="M156.62 280C141.09 280.38 128.48 277.78 118.42 273.95C130.753 277.973 143.647 280.015 156.62 280Z"
        fill="#4CC2F1"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_200">
        <rect width="314.09" height="314.09" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SvgCryo = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_211)">
      <path
        d="M157.22 11.84C157.22 11.84 133.13 65.69 118.22 81.61C118.53 81.5 123.51 79.61 129.86 76.45C135.53 84.45 157.18 116.36 157.18 139.15C157.18 116.36 178.83 84.42 184.5 76.45C190.85 79.56 195.83 81.45 196.14 81.61C181.31 65.69 157.22 11.84 157.22 11.84ZM157.22 117.42C156.682 100.336 152.049 83.6305 143.71 68.71C149.64 64.83 154.9 60.37 157.22 55.8C159.54 60.37 164.8 64.8 170.73 68.71C162.391 83.6305 157.758 100.336 157.22 117.42Z"
        fill="#9FD6E3"
      />
      <path
        d="M282.88 84.59C282.88 84.59 224.2 90.66 203 85.74C203.25 85.95 207.42 89.3 213.28 93.24C209.22 102.13 192.38 136.85 172.65 148.24C192.38 136.84 230.87 139.62 240.65 140.55C241.14 147.6 241.95 152.89 242.01 153.21C248.29 132.38 282.88 84.59 282.88 84.59ZM191.44 137.38C205.964 128.392 218.115 116.046 226.87 101.38C233.2 104.57 239.69 106.9 244.81 106.62C242.01 110.92 240.81 117.7 240.38 124.78C213.63 124.79 192.73 136.64 191.44 137.38Z"
        fill="#9FD6E3"
      />
      <path
        d="M282.7 229.8C282.7 229.8 248.11 182 241.76 161.17C241.7 161.49 240.89 166.78 240.41 173.83C230.67 174.76 192.19 177.54 172.41 166.14C192.15 177.54 208.98 212.25 213.05 221.14C207.18 225.08 203.05 228.43 202.76 228.64C224 223.73 282.7 229.8 282.7 229.8ZM191.27 177C206.336 185.072 223.119 189.411 240.21 189.65C240.6 196.73 241.84 203.51 244.63 207.81C239.52 207.53 233.02 209.81 226.7 213.05C217.946 198.371 205.795 186.008 191.27 177Z"
        fill="#9FD6E3"
      />
      <path
        d="M156.87 302.24C156.87 302.24 180.96 248.39 195.87 232.47C195.56 232.58 190.58 234.52 184.23 237.63C178.56 229.63 156.91 197.72 156.91 174.93C156.91 197.72 135.26 229.66 129.59 237.63C123.24 234.52 118.26 232.63 117.95 232.47C132.78 248.39 156.87 302.24 156.87 302.24ZM156.87 196.66C157.407 213.744 162.041 230.45 170.38 245.37C164.45 249.25 159.19 253.71 156.87 258.28C154.55 253.71 149.29 249.28 143.36 245.37C151.699 230.45 156.332 213.744 156.87 196.66Z"
        fill="#9FD6E3"
      />
      <path
        d="M31.21 229.49C31.21 229.49 89.89 223.43 111.11 228.35C110.86 228.13 106.69 224.79 100.82 220.85C104.89 211.95 121.73 177.23 141.46 165.85C121.73 177.24 83.24 174.46 73.46 173.54C72.98 166.48 72.17 161.2 72.11 160.88C65.8 181.71 31.21 229.49 31.21 229.49ZM122.64 176.7C108.113 185.71 95.9621 198.076 87.21 212.76C80.89 209.56 74.4 207.24 69.28 207.51C72.08 203.22 73.28 196.43 73.7 189.36C90.7917 189.12 107.576 184.778 122.64 176.7Z"
        fill="#9FD6E3"
      />
      <path
        d="M31.3799 84.29C31.3799 84.29 65.9699 132.08 72.3799 152.92C72.4399 152.59 73.2499 147.31 73.7299 140.26C83.4599 139.33 121.95 136.55 141.73 147.95C121.99 136.55 105.15 101.83 101.09 92.95C106.96 88.95 111.09 85.66 111.38 85.45C90.0599 90.35 31.3799 84.29 31.3799 84.29ZM122.82 137.08C107.756 129.002 90.9712 124.664 73.8799 124.43C73.4799 117.35 72.2499 110.57 69.4499 106.27C74.5699 106.55 81.0599 104.27 87.3899 101.03C96.1443 115.709 108.295 128.072 122.82 137.08Z"
        fill="#9FD6E3"
      />
      <path
        d="M157.22 163.7C160.34 163.7 162.87 161.17 162.87 158.05C162.87 154.93 160.34 152.4 157.22 152.4C154.1 152.4 151.57 154.93 151.57 158.05C151.57 161.17 154.1 163.7 157.22 163.7Z"
        fill="#9FD6E3"
      />
      <path
        d="M153.85 138L155.85 155.62L141.56 145.12C139.664 143.728 138.106 141.926 137.003 139.848C135.9 137.771 135.28 135.471 135.19 133.12L134.74 120.76C134.751 120.596 134.802 120.437 134.889 120.298C134.976 120.158 135.096 120.043 135.238 119.961C135.381 119.878 135.541 119.833 135.705 119.827C135.87 119.822 136.033 119.857 136.18 119.93L146.66 126.49C148.646 127.745 150.324 129.432 151.568 131.425C152.813 133.417 153.593 135.665 153.85 138Z"
        fill="#9FD6E3"
      />
      <path
        d="M172.93 145.09L158.64 155.59L160.58 138C160.841 135.653 161.628 133.396 162.884 131.396C164.139 129.396 165.83 127.705 167.83 126.45L178.31 119.89C178.454 119.802 178.62 119.754 178.79 119.752C178.959 119.75 179.126 119.794 179.272 119.879C179.419 119.964 179.539 120.087 179.622 120.235C179.704 120.383 179.745 120.551 179.74 120.72L179.3 133.08C179.211 135.432 178.592 137.734 177.489 139.814C176.386 141.893 174.828 143.697 172.93 145.09Z"
        fill="#9FD6E3"
      />
      <path
        d="M176.29 165.18L160.06 158.05L176.29 150.92C178.451 149.97 180.8 149.523 183.159 149.611C185.518 149.699 187.826 150.321 189.91 151.43L200.83 157.22C200.981 157.3 201.107 157.42 201.195 157.566C201.282 157.712 201.329 157.879 201.329 158.05C201.329 158.221 201.282 158.388 201.195 158.534C201.107 158.68 200.981 158.8 200.83 158.88L189.91 164.67C187.825 165.777 185.517 166.397 183.158 166.486C180.8 166.574 178.452 166.128 176.29 165.18Z"
        fill="#9FD6E3"
      />
      <path
        d="M160.58 178.13L158.64 160.51L172.93 171C174.832 172.398 176.393 174.208 177.496 176.295C178.599 178.382 179.216 180.691 179.3 183.05L179.74 195.4C179.748 195.571 179.71 195.74 179.628 195.89C179.547 196.04 179.426 196.165 179.278 196.251C179.13 196.337 178.962 196.38 178.791 196.376C178.62 196.373 178.454 196.322 178.31 196.23L167.83 189.67C165.831 188.416 164.141 186.727 162.886 184.729C161.63 182.731 160.842 180.475 160.58 178.13Z"
        fill="#9FD6E3"
      />
      <path
        d="M141.51 171L155.8 160.51L153.8 178.13C153.542 180.475 152.757 182.732 151.503 184.73C150.25 186.729 148.56 188.418 146.56 189.67L136.08 196.23C135.935 196.321 135.769 196.371 135.598 196.374C135.427 196.378 135.258 196.334 135.11 196.249C134.962 196.163 134.84 196.039 134.757 195.89C134.674 195.74 134.634 195.571 134.64 195.4L135.09 183.05C135.18 180.687 135.805 178.375 136.917 176.288C138.029 174.201 139.599 172.393 141.51 171Z"
        fill="#9FD6E3"
      />
      <path
        d="M138.15 150.92L154.38 158.05L138.15 165.18C135.988 166.128 133.64 166.574 131.282 166.486C128.923 166.397 126.615 165.777 124.53 164.67L113.61 158.88C113.459 158.8 113.333 158.68 113.246 158.534C113.158 158.388 113.111 158.221 113.111 158.05C113.111 157.879 113.158 157.712 113.246 157.566C113.333 157.42 113.459 157.3 113.61 157.22L124.53 151.43C126.614 150.321 128.922 149.699 131.282 149.611C133.641 149.523 135.989 149.97 138.15 150.92Z"
        fill="#9FD6E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_211">
        <rect width="314.09" height="314.09" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SvgPyro = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_228)">
      <path
        d="M154.81 18.0601C154.81 18.0601 154.81 40.3401 141.81 56.9601C128.81 73.5801 117.87 83.5601 117.87 100.85C117.87 118.14 130.51 131.77 164.42 145.74C198.33 159.71 216 180.32 216 199.6C216 218.88 202.38 245.53 157.29 245.15C112.76 238.15 134.54 200.27 146.5 196.28C146.5 196.28 111.96 193.33 111.96 217.94C111.96 242.55 144.51 250.47 163.63 250.47C182.75 250.47 241.27 239.17 241.27 189.3C241.27 169.72 233.62 158.71 233.62 158.71C233.62 158.71 262.62 169.88 259.22 198.27C254.89 234.13 203.04 236.63 159.41 278.11C159.41 278.11 147.79 264.53 107.94 244.82C85.12 233.54 57.62 223.89 58.39 190.32C59.03 162.4 88.65 151.06 88.65 151.06C88.65 151.06 38.78 202.26 110.26 236.18C110.26 236.18 64.05 164.36 155.15 148.73C155.15 148.73 105.61 136.1 103.61 93.5401C103.61 93.5401 95.3 117.48 83.33 130.11C71.36 142.74 41.51 172.48 45.5 206.06C49.49 239.64 127.88 258.45 159.13 296.06C159.13 296.06 184.4 269.79 210 257.49C235.6 245.19 321.05 205.62 223 130.81C223 130.81 208 120.81 206.71 93.2301C198.259 102.387 193.518 114.36 193.41 126.82C193.41 147.43 208.08 143.82 209.7 163.03C209.7 163.03 180.77 138.45 181.1 119.17C181.43 99.8901 188.75 79.2701 188.75 79.2701C188.75 79.2701 138.55 102.21 163.48 138.45C163.48 138.45 145.19 131.14 149.18 106.53C153.17 81.9201 207.34 81.2301 154.81 18.0601Z"
        fill="#EF7938"
      />
      <path
        d="M169.94 227C169.94 227 197.37 218.44 197.37 197C197.37 175.56 156.65 137.66 123.3 187C123.3 187 154.97 171.54 168.94 192C182.91 212.46 169.94 227 169.94 227Z"
        fill="#EF7938"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_228">
        <rect width="314.09" height="314.09" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SvgDendro = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_249)">
      <path
        d="M172.23 78.43L157.05 96.1L141.86 78.43C138.519 74.5369 136.513 69.6755 136.137 64.5589C135.76 59.4424 137.034 54.3399 139.77 50L157.05 22.65L174.32 50C177.056 54.3399 178.329 59.4424 177.953 64.5589C177.577 69.6755 175.571 74.5369 172.23 78.43Z"
        fill="#A5C83B"
      />
      <path
        d="M268.12 172.71L267.34 173.28L267.93 173.79C261 213.01 229.72 230.21 211.93 238.73C191.82 248.35 157.07 268.17 157.07 291.48C157.07 268.17 122.31 248.35 102.2 238.73C84.4 230.21 53.12 213.01 46.2 173.8L46.8 173.28L46 172.7C45.1785 167.645 44.7738 162.531 44.79 157.41C44.79 106.41 85.31 83.96 110.66 83.96C129.8 83.96 143.66 95.41 149.25 101.03C150.071 101.851 150.583 102.93 150.701 104.085C150.82 105.239 150.537 106.4 149.9 107.37L145.83 113.62C145.621 113.943 145.337 114.21 145.004 114.402C144.67 114.593 144.295 114.702 143.911 114.719C143.527 114.737 143.144 114.663 142.794 114.503C142.445 114.343 142.138 114.102 141.9 113.8C136.59 107.14 120.7 91.66 93 102C72.29 109.75 59.33 129 59.33 152C59.33 175 73.54 208.43 110.74 222.22C147.94 236.01 157.05 258.3 157.05 258.3C157.05 258.3 166.16 236.01 203.36 222.22C240.56 208.43 254.77 175 254.77 152C254.77 129 241.77 109.79 221.12 102.06C193.4 91.7 177.5 107.18 172.22 113.84C171.982 114.142 171.675 114.383 171.326 114.543C170.976 114.703 170.593 114.777 170.209 114.759C169.825 114.742 169.45 114.633 169.116 114.442C168.783 114.25 168.499 113.983 168.29 113.66L164.22 107.41C163.587 106.438 163.306 105.279 163.424 104.125C163.543 102.971 164.053 101.893 164.87 101.07C170.51 95.41 184.33 84 203.46 84C228.82 84 269.33 106.44 269.33 157.45C269.344 162.561 268.94 167.665 268.12 172.71Z"
        fill="#A5C83B"
      />
      <path
        d="M46.76 173.28L46.16 173.8C46.09 173.44 46.02 173.07 45.97 172.7L46.76 173.28Z"
        fill="#A5C83B"
      />
      <path
        d="M140.75 206.42C109.08 178.58 101.75 160.07 108.93 143.42C116.11 126.77 136.06 133.48 136.06 133.48C118.99 115.78 104.57 119.09 96.5699 123.57C91.7448 126.329 87.8997 130.524 85.5699 135.57C79.0699 149.32 84.9999 162.63 95.0199 173.93C88.6999 174.45 80.8899 177.17 76.3899 186.37C76.3899 186.37 81.0399 181.6 87.3899 180.77C93.7399 179.94 100.09 179.6 105.01 183.57C121.32 197.37 140.75 206.42 140.75 206.42Z"
        fill="#A5C83B"
      />
      <path
        d="M60.8701 92.75C60.3594 88.8292 58.4799 85.215 55.5633 82.5454C52.6467 79.8758 48.8806 78.3226 44.9301 78.16L24.5701 77.33L29.3401 94.13C30.5382 98.3542 33.2214 102.004 36.8961 104.407C40.5709 106.81 44.9898 107.806 49.3401 107.21L62.4801 105.4L60.8701 92.75Z"
        fill="#A5C83B"
      />
      <path
        d="M46.76 173.28L46.16 173.8L38.27 180.63C36.2868 182.355 33.7919 183.382 31.1687 183.552C28.5455 183.722 25.9391 183.025 23.75 181.57L13.75 174.97L24.22 167.26C26.2817 165.742 28.7748 164.923 31.335 164.923C33.8952 164.923 36.3883 165.742 38.45 167.26L46 172.7L46.76 173.28Z"
        fill="#A5C83B"
      />
      <path
        d="M268.12 172.71C268.07 173.07 268 173.43 267.93 173.79L267.34 173.28L268.12 172.71Z"
        fill="#A5C83B"
      />
      <path
        d="M173.35 206.42C205.01 178.58 212.35 160.07 205.16 143.42C197.97 126.77 178 133.45 178 133.45C195.07 115.75 209.49 119.06 217.5 123.54C222.325 126.299 226.17 130.494 228.5 135.54C234.99 149.29 229.07 162.6 219.05 173.9C225.37 174.42 233.17 177.14 237.68 186.34C237.68 186.34 233.03 181.57 226.68 180.74C220.33 179.91 213.98 179.57 209.06 183.54C192.78 197.37 173.35 206.42 173.35 206.42Z"
        fill="#A5C83B"
      />
      <path
        d="M253.22 92.75C253.735 88.8308 255.615 85.2188 258.531 82.5499C261.447 79.881 265.211 78.3265 269.16 78.16L289.53 77.33L284.76 94.13C283.558 98.3519 280.874 101.999 277.201 104.401C273.527 106.804 269.11 107.801 264.76 107.21L251.62 105.4L253.22 92.75Z"
        fill="#A5C83B"
      />
      <path
        d="M300.3 175L290.3 181.6C288.112 183.053 285.508 183.748 282.886 183.578C280.265 183.408 277.772 182.383 275.79 180.66L267.89 173.82L267.3 173.31L268.08 172.74L275.56 167.26C277.623 165.74 280.118 164.919 282.68 164.919C285.242 164.919 287.737 165.74 289.8 167.26L300.3 175Z"
        fill="#A5C83B"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_249">
        <rect width="314.09" height="314.09" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SvgAnemo = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23_234)">
      <path
        d="M145.24 148.75C145.24 148.75 76.8899 104.14 112.89 24.5699C112.89 24.5699 72.3899 43.57 72.3899 78.0499C72.3899 126.18 114.06 140.47 145.24 148.75Z"
        fill="#74C2A8"
      />
      <path
        d="M136.37 189.38C136.37 205.23 112.89 205.62 112.89 205.62C114.26 223.62 141.89 220.68 141.7 193.49C141.51 166.3 124.43 164.92 84.7 163.36C44.97 161.8 27.76 117.18 27.76 117.18C27.76 117.18 12.32 163.94 44.9 182.73C77.48 201.52 111.13 175.29 116.8 174.73C122.47 174.17 136.37 173.53 136.37 189.38Z"
        fill="#74C2A8"
      />
      <path
        d="M241.7 78.0499C241.7 43.6199 201.2 24.5699 201.2 24.5699C237.2 104.14 168.85 148.75 168.85 148.75C200 140.47 241.7 126.18 241.7 78.0499Z"
        fill="#74C2A8"
      />
      <path
        d="M286.31 117.18C286.31 117.18 269.09 161.79 229.37 163.36C189.65 164.93 172.53 166.29 172.37 193.49C172.21 220.69 199.81 223.62 201.18 205.62C201.18 205.62 177.7 205.23 177.7 189.38C177.7 173.53 191.59 174.12 197.26 174.7C202.93 175.28 236.6 201.51 269.17 182.7C301.74 163.89 286.31 117.18 286.31 117.18Z"
        fill="#74C2A8"
      />
      <path
        d="M181.22 224.52C172.38 224.52 161.64 214.21 161.64 197.31L161.72 193.13C161.785 189.421 162.618 185.766 164.167 182.396C165.716 179.026 167.948 176.014 170.72 173.55C180.66 164.76 197.35 155.98 217.47 154.55C256.21 151.81 286.53 122.86 257.97 62.2C257.97 62.2 259.34 111.7 223.92 133.62C188.5 155.54 167.72 159.25 157.08 182.12C146.45 159.25 125.65 155.53 90.2401 133.62C54.8301 111.71 56.2401 62.2 56.2401 62.2C27.6801 122.86 58.0001 151.81 96.7401 154.55C116.86 155.98 133.54 164.76 143.48 173.55C146.256 176.011 148.49 179.023 150.039 182.394C151.588 185.764 152.42 189.421 152.48 193.13L152.56 197.31C152.56 214.21 141.82 224.52 132.98 224.52C129.577 224.559 126.193 224.004 122.98 222.88C121.276 222.272 119.464 222.03 117.66 222.167C115.856 222.305 114.102 222.821 112.51 223.68L110.29 224.86C144.47 251 157 289.51 157 289.51C157 289.51 169.57 251.03 203.88 224.86L201.66 223.68C200.069 222.82 198.314 222.304 196.51 222.166C194.706 222.029 192.894 222.272 191.19 222.88C187.987 224.002 184.613 224.557 181.22 224.52ZM157 268.35C157 263.01 144.67 246.44 144.67 246.44C149.731 245.177 154.133 242.058 157 237.7C159.867 242.058 164.269 245.177 169.33 246.44C169.33 246.44 157 263 157 268.35ZM162.83 234C160.712 232.488 158.77 230.744 157.04 228.8C155.315 230.745 153.376 232.489 151.26 234C149.075 235.482 146.49 236.263 143.85 236.24H137.15C137.15 236.24 156.36 227.04 157.01 216.69H157.07C157.72 227.04 176.93 236.24 176.93 236.24H170.24C167.6 236.263 165.015 235.482 162.83 234Z"
        fill="#74C2A8"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_234">
        <rect width="314.09" height="314.09" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SvgGeo = (
  <SvgIcon
    width="315"
    height="315"
    viewBox="0 0 315 315"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M249.57 189.64L251.63 188.01C261.968 179.854 269.994 169.136 274.91 156.92C274.91 156.92 215.85 68.49 157 29.73C157 29.73 91.0999 81.91 75.4399 109.73C75.4399 109.73 86.2499 148.73 95.1999 159.5C95.1999 159.5 142.83 113.96 157 109.3C157 109.3 175.34 122.6 183.55 145.71L154.84 172.92L163.42 184.48L206.66 147.57C206.66 147.57 184.91 105 157 81.54L102 128.14C102 128.14 114.46 84.15 157 42C157 42 232.05 127.39 249.57 189.64Z"
      fill="#FAB632"
    />
    <path
      d="M64.5199 124.44L62.4499 126.07C52.1147 134.233 44.0901 144.953 39.1699 157.17C39.1699 157.17 98.2399 245.59 157.05 284.36C157.05 284.36 222.95 232.17 238.61 204.36C238.61 204.36 227.79 165.36 218.85 154.6C218.85 154.6 171.2 199.7 157.04 204.36C157.04 204.36 138.7 191.5 130.5 168.36L159.2 141.15L150.63 129.59L107.39 166.5C107.39 166.5 129.18 208.99 157.05 232.5L212.14 186C212.14 186 199.63 230 157.05 272.11C157.05 272.06 81.9999 186.7 64.5199 124.44Z"
      fill="#FAB632"
    />
  </SvgIcon>
);

export const Svg5Star = (
  <SvgIcon
    width="82"
    height="82"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41 0L54.7365 21.285L79.9933 27.2938L63.2262 46.4575L65.0992 71.4562L41 62.015L16.9008 71.4562L18.7738 46.4575L2.00668 27.2938L27.2635 21.285L41 0Z"
      fill="#BF732A"
    />
    <path
      d="M35.176 26H50.08C50.248 26.024 50.332 26.12 50.332 26.288V26.576C50.332 28.256 49.36 29.552 47.416 30.464C47.008 30.656 46.264 30.752 45.184 30.752H38.236C37.684 34.472 37.408 36.56 37.408 37.016H37.552C38.2 36.656 39.592 36.416 41.728 36.296C46.456 36.296 49.516 38.108 50.908 41.732C51.268 42.62 51.448 43.88 51.448 45.512C51.448 49.64 49.252 52.46 44.86 53.972C43.516 54.332 41.932 54.512 40.108 54.512C36.676 54.32 34.3 53.42 32.98 51.812C31.684 50.204 31.024 48.656 31 47.168V46.016C31 45.512 31.18 45.2 31.54 45.08H35.032C35.296 45.104 35.44 45.248 35.464 45.512V45.656C35.464 49.256 37.036 51.056 40.18 51.056H40.324C42.772 51.056 44.344 49.808 45.04 47.312C45.136 46.808 45.184 46.388 45.184 46.052V44.648C45.184 42.512 44.356 40.988 42.7 40.076C41.86 39.692 40.972 39.5 40.036 39.5C38.5 39.5 36.604 39.944 34.348 40.832C33.844 41.144 33.532 41.204 33.412 41.012L32.548 40.58C32.38 40.436 32.344 40.16 32.44 39.752L34.744 26.468C34.768 26.18 34.912 26.024 35.176 26Z"
      fill="white"
    />
  </SvgIcon>
);

export const Svg4Star = (
  <SvgIcon
    width="82"
    height="82"
    viewBox="0 0 82 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41 0L54.7365 21.285L79.9933 27.2938L63.2262 46.4575L65.0992 71.4562L41 62.015L16.9008 71.4562L18.7738 46.4575L2.00668 27.2938L27.2635 21.285L41 0Z"
      fill="#AA77C1"
    />
    <path
      d="M46.4289 25.0026C46.9089 24.9786 47.1849 25.1226 47.2569 25.4346L47.2929 42.4986H52.5849C52.8489 42.5226 52.9809 42.6666 52.9809 42.9306V46.4226C52.8849 46.7106 52.6089 46.8546 52.1529 46.8546H47.2929V48.9786C47.2929 51.9306 45.3849 53.6946 41.5689 54.2706C41.4009 54.2466 41.3169 54.1146 41.3169 53.8746V46.8546H32.1009H29.9769C29.3049 46.7826 28.9929 46.5306 29.0409 46.0986C28.9209 45.0186 29.0649 44.2266 29.4729 43.7226L41.2809 25.5786C41.5209 25.2186 41.8449 25.0266 42.2529 25.0026H46.4289ZM41.1369 30.7266C40.8969 31.1586 39.3009 33.7746 36.3489 38.5746C35.6289 39.7506 34.8249 41.0586 33.9369 42.4986H41.3169L41.2809 30.7266H41.1369Z"
      fill="white"
    />
  </SvgIcon>
);

export const SvgEN = (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#012169" d="M0 0h640v480H0z" />
    <path
      fill="#FFF"
      d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
    />
    <path
      fill="#C8102E"
      d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
    />
    <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z" />
    <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" />
  </SvgIcon>
);

export const SvgFR = (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
    <path fill="#fff" d="M0 0h640v480H0z" />
    <path fill="#002654" d="M0 0h213.3v480H0z" />
    <path fill="#ce1126" d="M426.7 0H640v480H426.7z" />
  </SvgIcon>
);

export const SvgDividerRight = (
  <SvgIcon
    width="276"
    height="15"
    viewBox="0 0 276 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M257.218 3.97597L252.166 6.73176C251.652 7.01219 251.076 7.15913 250.49 7.15913H0V4.15913H250.49C250.574 4.15913 250.656 4.13813 250.729 4.09808L255.782 1.34229L257.218 3.97597Z"
      fill="url(#paint0_linear_183_10183)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M266.469 3.17203C263.764 5.52345 259.717 9.06319 259.061 9.71977L256.939 7.59845C257.722 6.81595 262.218 2.89036 264.842 0.611422C265.808 -0.226614 267.242 -0.197421 268.175 0.663607L275.212 7.15911L268.224 13.6096C267.238 14.5198 265.709 14.4892 264.76 13.5404L262.939 11.7198L265.061 9.59845L266.542 11.0794L270.789 7.15911L266.469 3.17203Z"
      fill="#A48F84"
    />
    <defs>
      <linearGradient
        id="paint0_linear_183_10183"
        x1="257"
        y1="6.9994"
        x2="-3.5"
        y2="6.99986"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#998377" />
        <stop offset="1" stopColor="#998377" stopOpacity="0" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const SvgDividerLeft = (
  <SvgIcon
    width="276"
    height="16"
    viewBox="0 0 276 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9926 4.94423L23.0449 7.70003C23.5591 7.98045 24.1353 8.12739 24.7209 8.12739H275.211V5.12739H24.7209C24.6373 5.12739 24.5549 5.1064 24.4815 5.06634L19.4292 2.31055L17.9926 4.94423Z"
      fill="url(#paint0_linear_202_8482)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.74164 4.14029C11.4473 6.49171 15.4936 10.0315 16.1502 10.688L18.2715 8.56671C17.489 7.78421 12.9931 3.85862 10.3685 1.57968C9.4034 0.741648 7.96892 0.77084 7.03614 1.63187L-0.000650406 8.12737L6.98741 14.5779C7.9734 15.488 9.50205 15.4575 10.4509 14.5086L12.2715 12.688L10.1502 10.5667L8.66925 12.0476L4.4223 8.12737L8.74164 4.14029Z"
      fill="#A48F84"
    />
    <defs>
      <linearGradient
        id="paint0_linear_202_8482"
        x1="18.211"
        y1="7.96767"
        x2="278.711"
        y2="7.96812"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#998377" />
        <stop offset="1" stopColor="#998377" stopOpacity="0" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const SvgDividerHorizontal = (
  <SvgIcon
    width="1545"
    height="28"
    viewBox="0 0 1545 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0410156 12.5187L15.511 8.15071C15.621 8.11971 15.725 8.07069 15.82 8.00669L27.348 0.213695C27.8 -0.0923055 28.409 -0.00928888 28.763 0.405711L37.437 10.5707C37.544 10.6967 37.679 10.7957 37.831 10.8607L53.828 17.6957C54.084 17.8057 54.372 17.8107 54.632 17.7117L56.967 16.8167C57.864 16.4737 58.724 17.3917 58.324 18.2647L56.001 23.3197C55.73 23.9087 55.004 24.1237 54.456 23.7787C54.456 23.7787 46.773 17.4747 42.548 16.2177C40.794 15.6957 38.755 15.7497 38.755 15.7497C38.755 15.7497 37.334 15.9767 36.046 16.9767C34.758 17.9767 33.603 19.7487 33.603 19.7487L29.546 26.4227C29.035 27.1677 27.993 27.3097 27.302 26.7277L18.364 19.2157L0 12.4937"
      fill="#51545D"
    />
    <path
      d="M1544.64 14.5677L1529.17 18.9357C1529.06 18.9667 1528.96 19.0157 1528.86 19.0797L1517.34 26.8737C1516.88 27.1787 1516.27 27.0957 1515.92 26.6817L1507.25 16.5157C1507.14 16.3897 1507 16.2907 1506.85 16.2257L1490.86 9.39073C1490.6 9.28073 1490.31 9.27574 1490.05 9.37474L1487.72 10.2697C1486.82 10.6127 1485.96 9.69474 1486.36 8.82274L1488.68 3.76674C1488.95 3.17874 1489.68 2.96273 1490.23 3.30873C1490.23 3.30873 1497.91 9.61173 1502.14 10.8687C1503.89 11.3907 1505.93 11.3367 1505.93 11.3367C1505.93 11.3367 1507.35 11.1097 1508.64 10.1097C1509.93 9.11072 1511.08 7.33772 1511.08 7.33772L1515.14 0.66374C1515.65 -0.0812603 1516.69 -0.222253 1517.38 0.358747L1526.32 7.87074L1544.68 14.5927"
      fill="#51545D"
    />
    <path
      d="M55.52 4.2336C54.972 4.1766 54.3511 4.26959 53.8941 4.57759C53.3851 4.92159 53.071 5.49859 52.676 5.95259C51.942 6.79659 51.2 7.61759 50.457 8.45259C50.058 8.90059 49.656 9.36959 49.27 9.82759C48.697 10.5066 48.778 11.5056 49.457 12.0776C50.136 12.6506 51.1661 12.5696 51.7381 11.8906C52.6561 10.8006 53.606 9.76859 54.551 8.70259C54.753 8.47459 54.9551 8.24458 55.1441 8.01558C55.3621 8.24058 55.582 8.47959 55.801 8.70259C56.097 9.00559 56.38 9.30658 56.676 9.60958C57.06 10.0016 57.448 10.4036 57.832 10.7966C59.053 12.0456 60.384 13.1936 62.02 13.8596C63.792 14.5796 66.0011 14.4376 67.8631 14.4836C73.2261 14.6186 78.6231 14.2946 83.9881 14.2966C98.7051 14.3016 113.426 14.3466 128.144 14.3596C208.538 14.4266 288.907 14.4896 369.301 14.5466C650.622 14.7466 931.952 14.9456 1213.27 15.1096C1284.26 15.1506 1355.24 15.2016 1426.24 15.2336C1438.33 15.2396 1450.42 15.2616 1462.52 15.2656C1465.71 15.2666 1468.92 15.2646 1472.11 15.2656C1473.05 15.2656 1473.98 15.2656 1474.92 15.2656C1475.2 15.2656 1475.49 15.2986 1475.77 15.2656C1475.84 15.2576 1475.86 15.1116 1475.92 15.1406C1476.99 15.6386 1477.94 16.3536 1478.96 16.9526C1480.05 17.5966 1481.15 18.2466 1482.24 18.8906C1483.33 19.5336 1484.43 20.1536 1485.52 20.7966C1486.06 21.1186 1486.6 21.4436 1487.14 21.7656C1487.84 22.1786 1488.52 22.6556 1489.36 22.7026C1490.97 22.7926 1492.36 21.1196 1493.46 20.1406C1493.9 19.7406 1494.35 19.3526 1494.8 18.9526C1495.24 18.5536 1495.7 18.1336 1496.14 17.7336C1496.84 17.1086 1496.89 16.0576 1496.27 15.3596C1495.64 14.6606 1494.56 14.5776 1493.86 15.2026C1492.97 16.0026 1492.07 16.8096 1491.17 17.6096C1490.6 18.1226 1490 18.6676 1489.42 19.2026C1488.71 18.7546 1487.93 18.3016 1487.24 17.8906C1486.69 17.5686 1486.16 17.2436 1485.61 16.9216C1485.07 16.5996 1484.5 16.2746 1483.96 15.9526C1482.86 15.3096 1481.8 14.6586 1480.7 14.0156C1480.16 13.6936 1479.6 13.3656 1479.05 13.0466C1478.43 12.6836 1477.85 12.2306 1477.17 11.9836C1476.73 11.8216 1476.24 11.8846 1475.77 11.8596C1473.85 11.7576 1471.9 11.8596 1469.99 11.8596C1466.05 11.8586 1462.11 11.8606 1458.17 11.8596C1446.78 11.8556 1435.38 11.8636 1423.99 11.8596C1353.04 11.8296 1282.09 11.7716 1211.14 11.7336C930.172 11.5856 649.212 11.4686 368.238 11.2966C287.551 11.2476 206.863 11.2066 126.176 11.1406C112.207 11.1286 97.7401 11.0896 83.9881 11.0776C80.1931 11.0746 76.376 11.1806 72.582 11.2656C69.802 11.3276 66.9111 11.4476 64.1441 11.0776C61.7121 10.7526 59.691 8.09559 58.082 6.45259C57.789 6.15359 57.497 5.84859 57.207 5.54659C56.757 5.07859 56.233 4.3096 55.52 4.2336Z"
      fill="#51545D"
    />
  </SvgIcon>
);

export const SvgDividerVertical = (
  <SvgIcon
    width="28"
    height="1545"
    viewBox="0 0 28 1545"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5184 1544.64L8.15046 1529.17C8.11946 1529.06 8.07045 1528.96 8.00645 1528.86L0.21345 1517.33C-0.0925496 1516.88 -0.00953302 1516.27 0.405467 1515.92L10.5704 1507.25C10.6964 1507.14 10.7955 1507 10.8605 1506.85L17.6954 1490.85C17.8054 1490.6 17.8105 1490.31 17.7115 1490.05L16.8164 1487.72C16.4734 1486.82 17.3914 1485.96 18.2644 1486.36L23.3195 1488.68C23.9085 1488.95 24.1235 1489.68 23.7785 1490.23C23.7785 1490.23 17.4744 1497.91 16.2174 1502.13C15.6954 1503.89 15.7495 1505.93 15.7495 1505.93C15.7495 1505.93 15.9764 1507.35 16.9764 1508.64C17.9764 1509.92 19.7485 1511.08 19.7485 1511.08L26.4225 1515.14C27.1675 1515.65 27.3095 1516.69 26.7275 1517.38L19.2155 1526.32L12.4934 1544.68"
      fill="#51545D"
    />
    <path
      d="M14.5677 0.0398369L18.9357 15.5099C18.9667 15.6199 19.0157 15.7199 19.0797 15.8199L26.8737 27.3399C27.1787 27.7999 27.0957 28.4099 26.6817 28.7599L16.5157 37.4299C16.3897 37.5399 16.2907 37.6799 16.2257 37.8299L9.39073 53.8199C9.28073 54.0799 9.27574 54.3699 9.37474 54.6299L10.2697 56.9599C10.6127 57.8599 9.69474 58.7199 8.82274 58.3199L3.76674 55.9999C3.17874 55.7299 2.96273 54.9999 3.30873 54.4499C3.30873 54.4499 9.61173 46.7698 10.8687 42.5398C11.3907 40.7898 11.3367 38.7499 11.3367 38.7499C11.3367 38.7499 11.1097 37.3298 10.1097 36.0398C9.11072 34.7498 7.33772 33.5999 7.33772 33.5999L0.66374 29.5398C-0.0812603 29.0298 -0.222253 27.9898 0.358747 27.2998L7.87074 18.3599L14.5927 -8.01086e-05"
      fill="#51545D"
    />
    <path
      d="M4.23458 1489.16C4.17758 1489.71 4.27057 1490.33 4.57857 1490.79C4.92257 1491.3 5.49957 1491.61 5.95357 1492.01C6.79757 1492.74 7.61857 1493.48 8.45357 1494.22C8.90157 1494.62 9.37057 1495.03 9.82857 1495.41C10.5076 1495.98 11.5066 1495.9 12.0786 1495.22C12.6516 1494.55 12.5706 1493.52 11.8916 1492.94C10.8016 1492.03 9.76957 1491.08 8.70357 1490.13C8.47557 1489.93 8.24556 1489.73 8.01656 1489.54C8.24156 1489.32 8.48057 1489.1 8.70357 1488.88C9.00657 1488.58 9.30755 1488.3 9.61055 1488.01C10.0026 1487.62 10.4046 1487.23 10.7976 1486.85C12.0466 1485.63 13.1946 1484.3 13.8606 1482.66C14.5806 1480.89 14.4386 1478.68 14.4846 1476.82C14.6196 1471.46 14.2956 1466.06 14.2976 1460.69C14.3026 1445.98 14.3476 1431.26 14.3606 1416.54C14.4276 1336.14 14.4906 1255.77 14.5476 1175.38C14.7476 894.06 14.9466 612.73 15.1106 331.41C15.1516 260.42 15.2026 189.44 15.2346 118.44C15.2406 106.35 15.2626 94.2599 15.2666 82.1599C15.2676 78.97 15.2656 75.7598 15.2666 72.5698C15.2666 71.6299 15.2666 70.6998 15.2666 69.7599C15.2666 69.4799 15.2996 69.1899 15.2666 68.9099C15.2586 68.84 15.1126 68.8199 15.1416 68.7599C15.6396 67.6899 16.3546 66.7399 16.9536 65.7198C17.5976 64.6299 18.2476 63.5298 18.8916 62.4398C19.5346 61.3499 20.1546 60.2499 20.7976 59.1599C21.1196 58.6199 21.4446 58.0798 21.7666 57.5398C22.1796 56.8398 22.6566 56.1598 22.7036 55.3198C22.7936 53.7098 21.1206 52.3198 20.1416 51.2198C19.7416 50.7799 19.3536 50.3298 18.9536 49.8799C18.5546 49.4399 18.1346 48.9797 17.7346 48.5398C17.1096 47.8398 16.0586 47.7899 15.3606 48.4099C14.6616 49.0399 14.5786 50.1199 15.2036 50.8198C16.0036 51.7098 16.8106 52.6099 17.6106 53.5099C18.1236 54.0798 18.6686 54.6799 19.2036 55.2599C18.7556 55.9698 18.3026 56.7499 17.8916 57.4398C17.5696 57.9899 17.2446 58.5198 16.9226 59.0698C16.6006 59.6099 16.2756 60.1798 15.9536 60.7198C15.3106 61.8198 14.6596 62.8799 14.0166 63.9799C13.6946 64.5199 13.3666 65.0798 13.0476 65.6299C12.6846 66.2499 12.2316 66.8298 11.9846 67.5099C11.8226 67.9498 11.8856 68.4399 11.8606 68.9099C11.7586 70.83 11.8606 72.7798 11.8606 74.6898C11.8596 78.6298 11.8616 82.5699 11.8606 86.5099C11.8566 97.8999 11.8646 109.3 11.8606 120.69C11.8306 191.64 11.7726 262.59 11.7346 333.54C11.5866 614.51 11.4696 895.47 11.2976 1176.44C11.2486 1257.13 11.2076 1337.82 11.1416 1418.51C11.1296 1432.47 11.0906 1446.94 11.0786 1460.69C11.0756 1464.49 11.1816 1468.31 11.2666 1472.1C11.3286 1474.88 11.4486 1477.77 11.0786 1480.54C10.7536 1482.97 8.09657 1484.99 6.45357 1486.6C6.15457 1486.89 5.84956 1487.18 5.54756 1487.47C5.07956 1487.92 4.31058 1488.45 4.23458 1489.16Z"
      fill="#51545D"
    />
  </SvgIcon>
);

export const SvgVS = (
  <SvgIcon
    width="136"
    height="137"
    viewBox="0 0 136 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.8257 2.25251C37.8303 5.697 24.4516 14.1377 14.8861 26.1888C5.32063 38.24 0.136875 53.1853 0.185891 68.5712C0.234907 83.9571 5.51378 98.8691 15.1558 110.859C24.7979 122.849 38.2301 131.204 53.2472 134.553L54.2779 129.931C40.3094 126.816 27.8151 119.044 18.8462 107.891C9.87741 96.7385 4.96712 82.8677 4.92152 68.5561C4.87593 54.2445 9.69774 40.3427 18.5953 29.133C27.4929 17.9233 39.9375 10.072 53.8859 6.86797L52.8257 2.25251Z"
      fill="#20C9FF"
    />
    <path
      d="M83.1938 2.25251C98.1893 5.697 111.568 14.1377 121.133 26.1888C130.699 38.24 135.883 53.1853 135.834 68.5712C135.785 83.9571 130.506 98.8691 120.864 110.859C111.222 122.849 97.7894 131.204 82.7723 134.553L81.7416 129.931C95.7101 126.816 108.204 119.044 117.173 107.891C126.142 96.7385 131.052 82.8677 131.098 68.5561C131.144 54.2445 126.322 40.3427 117.424 29.133C108.527 17.9233 96.0821 10.072 82.1336 6.86797L83.1938 2.25251Z"
      fill="#FF4444"
    />
    <g filter="url(#filter0_d_301_11407)">
      <path
        d="M104.123 55.2637H104.416C104.807 55.3126 105.027 55.5814 105.075 56.07L107.714 73.2955C107.714 73.9307 107.445 74.2484 106.908 74.2484H103.463C102.779 74.2972 102.314 74.0285 102.07 73.4421C98.6495 67.7736 94.0072 64.7194 88.1432 64.2796C83.5497 64.2796 81.253 66.3809 81.253 70.5834C81.253 74.1506 85.822 77.8401 94.9601 81.6517C104.685 85.6098 109.767 91.5227 110.206 99.3902C110.549 110.043 103.585 115.492 89.316 115.736C80.4223 115.834 73.6054 111.973 68.8653 104.155C68.6699 103.666 68.6699 103.251 68.8653 102.909L71.5041 100.05C72.1394 99.8544 72.6525 100.025 73.0434 100.563C77.588 105.889 82.9145 108.65 89.0228 108.846C95.4732 108.846 98.6984 106.622 98.6984 102.176C98.454 99.5857 93.8117 95.8718 84.7714 91.034C77.246 86.3917 72.5303 81.7494 70.6245 77.1071C69.7938 75.1035 69.5739 72.5136 69.9648 69.3373C72.1638 61.1766 78.6631 57.1695 89.4626 57.3161C93.6651 57.5116 97.3301 58.4401 100.458 60.1015C102.168 59.4174 103.39 57.8048 104.123 55.2637Z"
        fill="#FF4444"
      />
    </g>
    <g filter="url(#filter1_d_301_11407)">
      <path
        d="M22.8983 30.4631H42.1762C43.3001 30.4631 44.082 31.0495 44.5218 32.2223C42.3716 32.4177 41.1011 33.786 40.7102 36.327C48.1868 60.2716 52.1694 72.2439 52.658 72.2439L64.6792 36.6202C64.6792 34.861 63.4087 33.395 60.8676 32.2223C61.2585 31.0495 62.0404 30.4631 63.2132 30.4631H76.9203C78.2885 30.4631 78.9727 31.1716 78.9727 32.5888C75.5031 33.4195 73.2797 34.7633 72.3024 36.6202L54.9303 87.417C53.8064 87.9545 52.5603 88.2477 51.192 88.2966C47.3316 88.3943 44.6928 86.1709 43.2757 81.6263C33.4535 54.7497 27.8094 39.65 26.3434 36.327C24.2422 33.8348 22.3119 32.5888 20.5527 32.5888V31.9291C21.0414 30.9517 21.8233 30.4631 22.8983 30.4631Z"
        fill="#20C9FF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_301_11407"
        x="66.7188"
        y="55.2637"
        width="49.5"
        height="68.4742"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_301_11407"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_301_11407"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_301_11407"
        x="18.5527"
        y="30.4631"
        width="66.4199"
        height="65.8366"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_301_11407"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_301_11407"
          result="shape"
        />
      </filter>
    </defs>
  </SvgIcon>
);

export const SvgSortConstelDesc = (
  <SvgIcon
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54536 14C8.86081 14 8.23665 13.9083 7.6729 13.7248C7.11922 13.551 6.64104 13.2806 6.23836 12.9136C5.83568 12.5467 5.52864 12.0832 5.31723 11.5231C5.10582 10.963 5.00012 10.3112 5.00012 9.56769C4.99005 7.54949 5.61924 5.87892 6.88768 4.55599C8.16618 3.23305 9.54033 2.39294 11.0101 2.03565C11.2316 1.9584 11.3675 2.00669 11.4178 2.1805L11.75 2.81783C11.7601 2.85645 11.7651 2.89025 11.7651 2.91922C11.7752 3.01578 11.7198 3.09786 11.599 3.16546C10.995 3.46481 10.4363 3.81727 9.92287 4.22284C9.40946 4.62841 8.97658 5.10158 8.62423 5.64234C8.28195 6.1831 8.06048 6.6611 7.95981 7.07632C8.23162 6.90251 8.54873 6.75283 8.91114 6.6273C9.27355 6.50176 9.6863 6.439 10.1494 6.439C11.3675 6.439 12.3138 6.76249 12.9883 7.40947C13.6628 8.0468 14 8.97864 14 10.205C14 10.8134 13.8943 11.3541 13.6829 11.8273C13.4816 12.3005 13.1846 12.6964 12.792 13.015C12.4094 13.3337 11.9413 13.5751 11.3876 13.7393C10.8339 13.9131 10.2198 14 9.54536 14ZM7.5974 10.1905C7.63767 11.0306 7.82391 11.6631 8.15612 12.088C8.49839 12.5033 8.96148 12.7109 9.54536 12.7109C10.1192 12.7109 10.5722 12.5033 10.9044 12.088C11.2467 11.6631 11.4178 11.0355 11.4178 10.205C11.4178 9.37456 11.2467 8.75655 10.9044 8.35098C10.5722 7.93575 10.1192 7.72813 9.54536 7.72813C9.23328 7.72813 8.92121 7.78607 8.60913 7.90195C8.29706 8.01783 8.01518 8.18199 7.7635 8.39443C7.6427 8.89657 7.58733 9.49527 7.5974 10.1905Z"
      fill="white"
    />
    <path
      d="M5 22C5 19.995 5.39677 18.4963 6.19032 17.5037C6.98387 16.5012 8.0871 16 9.5 16C10.9129 16 12.0161 16.5012 12.8097 17.5037C13.6032 18.4963 14 19.995 14 22C14 23.0025 13.8984 23.8809 13.6952 24.6352C13.4919 25.3797 13.1968 26.005 12.8097 26.5112C12.4226 27.0074 11.9484 27.3797 11.3871 27.6278C10.8355 27.8759 10.2065 28 9.5 28C8.0871 28 6.98387 27.5037 6.19032 26.5112C5.39677 25.5087 5 24.005 5 22ZM7.52581 22C7.52581 23.5881 7.69516 24.7692 8.03387 25.5434C8.37258 26.3176 8.86129 26.7047 9.5 26.7047C10.1387 26.7047 10.6274 26.3176 10.9661 25.5434C11.3048 24.7692 11.4742 23.5881 11.4742 22C11.4742 20.4119 11.3048 19.2308 10.9661 18.4566C10.6274 17.6824 10.1387 17.2953 9.5 17.2953C8.86129 17.2953 8.37258 17.6824 8.03387 18.4566C7.69516 19.2308 7.52581 20.4119 7.52581 22Z"
      fill="white"
    />
    <path
      d="M22.9785 27.6487L26.7928 20.7711C27.2303 20.0069 26.9295 19.4163 26.3143 19.4163H23.8671V3.86046C23.8671 2.50465 23.2519 2 22.5 2C21.7481 2 21.1329 2.50465 21.1329 3.86046V19.4163H18.6857C18.0705 19.4163 17.7697 20.0069 18.2072 20.7711L22.0215 27.6487C22.2813 28.1171 22.7187 28.1171 22.9785 27.6487Z"
      fill="white"
    />
  </SvgIcon>
);

export const SvgJoker = (
  <SvgIcon
    height="800px"
    width="800px"
    viewBox="0 0 288.155 288.155"
    fill="none"
  >
    <path
      d="M268.716,115.677c-10.702,0-19.378,8.649-19.434,19.337c-23.02-0.545-45.599,6.505-66.54,17.426l-32.435-95.787
	c7.676-2.599,13.208-9.846,13.208-18.4c0-10.736-8.703-19.439-19.439-19.439s-19.439,8.703-19.439,19.439
	c0,8.554,5.532,15.801,13.208,18.4l-32.474,95.903c-20.929-10.91-43.492-17.95-66.497-17.406c0-0.012,0.002-0.023,0.002-0.035
	c0-10.736-8.703-19.439-19.439-19.439S0,124.38,0,135.116c0,10.736,8.703,19.439,19.439,19.439c6.321,0,11.92-3.031,15.471-7.703
	c13.722,11.857,32.076,37.776,35.311,92.514c-8.053,0.264-14.505,6.858-14.505,14.975c0,8.284,6.716,15,15,15h146.724
	c8.284,0,15-6.716,15-15c0-8.12-6.456-14.716-14.513-14.975c3.208-54.749,21.53-80.705,35.257-92.596
	c3.547,4.72,9.174,7.786,15.533,7.786c10.736,0,19.439-8.703,19.439-19.439C288.155,124.38,279.452,115.677,268.716,115.677z"
    />
  </SvgIcon>
);
